/* AppGridSection.tsx generated by @compiled/babel-plugin v0.36.0 */
import { ax, ix, CC, CS } from "@compiled/react/runtime";
import Heading from '@atlaskit/heading';
import { media } from '@atlaskit/primitives/responsive';
import React from 'react';
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
const _12 = "@media (min-width:64rem){._pdlmpxbi{gap:var(--ds-space-200,1pc)}._1rqtmqsn{grid-template-columns:repeat(auto-fill,minmax(max(17pc,var(--desktop-grid-size)),1fr))}}";
const _11 = "@media (min-width:48rem) and (max-width:63.99rem){._1gzvpxbi{gap:var(--ds-space-200,1pc)}._1da71bik{grid-template-columns:repeat(var(--tablet-columns,2),minmax(0,1fr))}}";
const _10 = "._yv0e17qr{grid-template-columns:repeat(var(--mobile-columns,1),minmax(0,1fr))}";
const _9 = "._19pkpxbi{margin-top:var(--ds-space-200,1pc)}";
const _8 = "._1p57pxbi{row-gap:var(--ds-space-200,1pc)}";
const _7 = "._1e0c11p5{display:grid}";
const _6 = "._qtt8glyw{list-style:none}";
const _5 = "._19bvidpf{padding-left:0}";
const _4 = "._n3tdidpf{padding-bottom:0}";
const _3 = "._u5f3idpf{padding-right:0}";
const _2 = "._ca0qidpf{padding-top:0}";
const _ = "._19pk1ejb{margin-top:var(--ds-space-300,24px)}";
/**
 * Generates CSS custom properties for responsive grid layout
 *
 * @param mobileColumns - Number of columns on mobile devices
 * @param tabletColumns - Number of columns on tablet devices
 * @param desktopColumns - Number of columns on desktop devices
 * @returns CSS custom properties object
 */
export const getGridVars = function getGridVars() {
  let mobileColumns = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
  let tabletColumns = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
  let desktopColumns = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 3;
  return {
    '--mobile-columns': mobileColumns,
    '--tablet-columns': tabletColumns,
    '--desktop-columns': desktopColumns,
    '--desktop-grid-size': "calc((100% - ".concat((desktopColumns - 1) * 32, "px)/").concat(desktopColumns, ")")
  };
};
const wrapperStyle = null;
const appTilesGridContainerCompactStyle = null;
/**
 * Wrapper component for app grid sections with optional heading
 */
export const AppGridSection = _ref => {
  let {
    title,
    gridVars,
    children
  } = _ref;
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_]
    }), /*#__PURE__*/_jsxs("div", {
      className: ax(["_19pk1ejb"]),
      children: [title && /*#__PURE__*/_jsx(Heading, {
        size: "small",
        children: title
      }), /*#__PURE__*/_jsxs(CC, {
        children: [/*#__PURE__*/_jsx(CS, {
          children: [_2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12]
        }), /*#__PURE__*/_jsx("ul", {
          style: gridVars,
          className: ax(["_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _qtt8glyw _1e0c11p5 _1p57pxbi _19pkpxbi _yv0e17qr _1gzvpxbi _1da71bik _pdlmpxbi _1rqtmqsn"]),
          children: children
        })]
      })]
    })]
  });
};